__turbopack_context__.v({
  "className": "Qcg0pG_className",
  "variable": "Qcg0pG_variable",
});
